module.exports = __webpack_public_path__ + "img/editing_1.d3fbfc5b.png";